import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { MoveHouseDetails } from "../MoveHouseDetails";
import DashboardInventoryList, {
  EditInventoryOnCallBack,
} from "../DashboardInventoryList";
import { AdditionalInformation } from "../AdditionalInformation";
import { VendorQuoteList } from "../vendor_quote/VendorQuoteList";
import Immutable from "immutable";
import momentTimeZone from "moment-timezone";
import {
  AddressInfo,
  MoveItemsInfo,
  EstimateMoveDate,
  ActionButtons,
} from "../estimate_details/MoveDetails";
import { StorageItems } from "../../inventory/StorageItems";
export default function EstimateQuotesReceived(props) {
  const { data, updateMoveDateInfo } = props;
  const [showMoveDetails, setShowMoveDetails] = useState(false);
  const [showVendorQuotes, setShowVendorQuotes] = useState(false);
  //callback 0 or 1 check for move type.
  const inventoryData = Immutable.fromJS(data.items);
  const clientTz = momentTimeZone.tz.guess();

  const moveDate = momentTimeZone.utc(data.moving_on).tz(clientTz);
  const showMoveDetailsFn = (params) => {
    setShowMoveDetails(!showMoveDetails);
    setShowVendorQuotes(false);
  };
  const showVendorQuotesFn = (params) => {
    setShowVendorQuotes(!showVendorQuotes);
    setShowMoveDetails(false);
  };

  const JSX = (
    <div className="move-container">
      <AddressInfo
        movingFrom={data.moving_from}
        movingTo={data.moving_to}
        fromAddress={data.from_address}
        toAddress={data.to_address}
        estimateId={data.estimate_id}
        estimateDetails={data}
      />
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 dashboard-item-common-spacing">
          <MoveItemsInfo
            propertySize={data.property_size}
            callback={data.call_back}
            totalItems={data.total_items}
            items={data.items}
            serviceType={data.service_type}
            inventoryData={inventoryData}
            distance={data.distance}
          />
        </div>
        <div className="col-sm-12 col-md-12 col-lg-4 dashboard-item-common-spacing">
          <EstimateMoveDate
            moveDateObj={moveDate}
            moveDateFlexible={data.move_date_flexible}
            handleMoveDateUpdate={() => {
              const state = {
                estimateId: data.estimate_id,
                moveDate: moveDate.format("YYYY-MM-DD HH:mm:ss"),
                moveDateFlexible: data.move_date_flexible,
                status: data.status,
              };
              updateMoveDateInfo(state);
            }}
            disableEdit={false}
          />
        </div>
        <div className="col-sm-12 col-md-12 col-lg-4 move-action-list dashboard-item-common-spacing">
          <ActionButtons
            showMoveDetailsFn={showMoveDetailsFn}
            showVendorQuotesFn={showVendorQuotesFn}
            data={data}
          />
        </div>
      </div>
      {data.move_date_flexible === "1" && (
        <div className="row mt-2">
          <div className="col-12 font-size-md mb-2">
            <span className="highlight-text mr-2">
              <FontAwesomeIcon icon={faExclamationTriangle} />
            </span>
            <strong>Disclaimer:</strong> Please update your move date before two
            days of shifting
          </div>
        </div>
      )}

      {/* View Move Details */}
      {showMoveDetails === true && (
        <div className="row">
          <div className="col-12">
            <AdditionalInformation
              additionalInfo={data.old_house_additional_info}
              editDisabled={true}
            />
            {/* house details Ex:floor no, DTT,etc */}
            <MoveHouseDetails moveData={data} editDisabled={true} />
            {data.call_back !== "1" && data.service_type === "relocation" && (
              <DashboardInventoryList
                inventoryItems={inventoryData}
                editDisabled={true}
              />
            )}
            {data.call_back === "1" && data.service_type === "relocation" && (
              <EditInventoryOnCallBack
                editDisabled={true}
              />
            )}
            {data.call_back === "1" && data.service_type === "storage" && (
              <StorageItems 
                items={data.storage_items}
                estimateId={data.estimate_id}
                editDisabled={true}
              />
            )}
          </div>
        </div>
      )}
      {/* Vendor quotes booking */}
      {showVendorQuotes === true && (
        <VendorQuoteList
          estimateComparison={data.estimate_comparison}
          estimateId={data.estimate_id}
        />
      )}
      <hr />
    </div>
  );
  return JSX;
}
